import Profile from './profile.vue';
import Heading from './heading.vue';
import Statistics from './statistics.vue';
import StatisticsFilter from './statistics_filter.vue';
import Charts from './charts.vue';
import Userlist from './userlist.vue';
import Paging from './paging.vue';
import Default from './default.vue';

import JobseAmbassadorRequest from './jobse/ambassador_request.vue';

export default {
	// Normal fields
	"profile": Profile,
	"heading": Heading,
	"statistics": Statistics,
	"statistics_filter": StatisticsFilter,
	"charts": Charts,
	"userlist": Userlist,
	"paging": Paging,
	"default": Default,

	"jobse/ambassador_request": JobseAmbassadorRequest,
};